import { Typography } from 'antd';
import styled from 'styled-components';

export const MpTitle = styled(Typography.Title)`
	&.ant-typography {
		margin-bottom: 24px;
		font-size: 24px;
	}
	@media (max-width: 575px) {
		&.ant-typography {
			margin-bottom: 16px;
			font-weight: 700;
			font-size: 20px;
		}
	}
`;
